import Form from 'shared/migration-components/form';
import {Link, useNavigate} from 'react-router-dom';
import useFormInputs from 'shared/migration-components/form/util';
import GoogleAuthButton from 'shared/components/google-auth-button';
import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';

import {
  Card,
  Container,
  Line,
  LinkText,
  Register,
  Separator,
  SeparatorText,
  Content,
  ForgotPasswordLink,
} from './styles';
import useLogin from 'modules/auth/hooks/use-login';
import AppleAuthButton from 'shared/components/apple-auth-button';

const Login: React.FC = () => {
  const {getInput, getCustomInput} = useFormInputs();
  const loginMutation = useLogin();
  const navigate = useNavigate();
  const theme = localStorage.getItem('theme');

  return (
    <Container>
      <Content>
        <Card>
          <img
            src={theme === 'dark' ? darkLogo : logo}
            style={{
              width: 180,
              height: 120,
              alignSelf: 'center',
              marginLeft: -20,
            }}
          />
          <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
            <Form
              inputs={[
                getInput({name: 'email'}),
                getInput({name: 'password', secureText: true}),
                getCustomInput({
                  name: 'forgot-password',
                  label: 'Esqueci minha senha',
                  component: (
                    <ForgotPasswordLink
                      onClick={() => navigate('/reset-password/request')}>
                      Esqueci minha senha
                    </ForgotPasswordLink>
                  ),
                }),
              ]}
              translationKey="UserProps"
              onSubmit={() => loginMutation}
              buttonProps={{
                title: 'Entrar',
                widthMode: 'expand',
              }}
            />
          </div>
          <Separator>
            <Line />
            <SeparatorText>OU</SeparatorText>
            <Line />
          </Separator>
          <GoogleAuthButton />
        </Card>
        <Register>
          Não tem uma conta?
          <Link to="/register">
            <LinkText> Cadastre-se</LinkText>
          </Link>
        </Register>
      </Content>
    </Container>
  );
};

export default Login;
